import React from 'react';

const stateToCss = (state) => {
  switch (state) {
    case 'added':
      return 'positive';
    case 'removed':
      return 'negative';
    default:
      return '';
  }
};

export default function UnorderedListChangeCard({ title, description, data }) {
  const shouldShowImpact = data.some((v) => v.impact);

  const row = (obj) => {
    return (
      <div
        key={obj.name}
        className='row values'
      >
        <div className={`column ${obj.state == 'added' && 'empty'}`}>
          {obj.state == 'added' ? '' : obj.name}
        </div>
        <div className={`column ${stateToCss(obj.state)}`}>{obj.name}</div>
        {shouldShowImpact && (
          <div className='one wide column impact'>
            {obj.impact ? obj.impact : '0'}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='ui fluid card'>
      <div className='content'>
        <div className='header'>{title}</div>
        <p className='meta'>{description}</p>
        <div
          className='ui divider'
          style={{ margin: 0 }}
        ></div>
        <div className='ui equal width grid properties'>
          <div className='row bold'>
            <div className='column'>Current Property List</div>
            <div className='column'>Proposed Property List</div>
            {shouldShowImpact && <div className='one wide column'>Impact</div>}
          </div>
          {data.map((v) => row(v))}
        </div>
      </div>
    </div>
  );
}
